module.exports = __webpack_public_path__ + "img/gsheets-leadjet.96dddfd1.png";